import * as React from "react";
import { getJSON } from "jquery";
import { isArray, isEmpty, isUndefined } from "lodash";

import { SelectBlockValidate } from "../../core/validation/validate";
import { IControlError, IControlSchema } from "../../core/Controls";
import { Component, I18NString, buildUrl } from "../helpers/Utils";
import { IDispatcher } from "../helpers/Dispatcher";

import Note from "./components/Note";
import Field from "./components/Field";
import ErrorAlert from "./components/ErrorAlert";

export interface ISelectBlockSchema extends IControlSchema {
	description: I18NString;
	disabled?: boolean;
	defaultValue?: string;
	value?: Array<string>;
	label?: string;
	extra: any;
	maxSelected?: number;
	minSelected?: number;
}

export interface ISelectBlockProps {
	schema: ISelectBlockSchema;
	api: any;
	dispatcher?: IDispatcher;
	error: IControlError | undefined;
	visited: boolean;
	opts: any;
}

interface IState {
	value: Array<string>;
	openInfo: boolean;
	searchString: string;
	currentItem: any;
	dataSrc: {
		loading: boolean;
		data?: [];
		error?: string | boolean;
	} | null;
}

const Help = ({ onClick }) => (
	<span onClick={onClick} className="input-group-addon btn btn-default">
		<span className="glyphicon glyphicon-question-sign" />
	</span>
);

const getTitle = (title, interfaceLang) => (title && (title[interfaceLang] || title)) || "";
const Arrow = () => <div className="sort__arrow" />;
const ArrowActive = () => <div className="sort__arrow sort__arrow_active" />;

export class SelectBlock extends Component<ISelectBlockProps, IState> {
	// private input: HTMLInputElement | HTMLTextAreaElement;

	state = {
		value: [],
		openInfo: false,
		searchString: "",
		currentItem: null,
		dataSrc: null,
	};

	public componentDidMount() {
		const {
			schema: {
				extra: { dataSrcUrl },
			},
			opts: {
				ext_rules: { HOST, URL_PREFIX },
			},
			api: { options },
		} = this.props;

		if (dataSrcUrl) {
			// TODO Делаем запрос на этот адрес, и обновляем состояние исходя из ответа
			this.setState({
				dataSrc: {
					loading: true,
				},
			});

			const dataUrlSubstituted = buildUrl(dataSrcUrl, options);

			getJSON(`${HOST}${URL_PREFIX}${dataUrlSubstituted}`, (data) => {
				this.setState({
					dataSrc: {
						loading: false,
						data,
						error: false,
					},
				});

				this.validate(data);
			});
		} else {
			this.validate();
		}
	}

	// TODO: ВЕРНУЛ апдейт компонента (возможно всплывут баги)
	// eslint-disable-next-line react/no-deprecated,react/sort-comp
	componentWillUpdate?(nextProps: Readonly<ISelectBlockProps>, nextState: Readonly<IState>): void {
		if (
			this.props.schema.value !== nextProps.schema.value &&
			nextState.value !== nextProps.schema.value &&
			this.state.value !== nextState.value
		) {
			// eslint-disable-next-line react/no-will-update-set-state
			this.setState({ value: nextProps.schema.value !== undefined ? nextProps.schema.value : [] });
		}
	}

	onClick = () => {
		this.setState(({ openInfo }) => ({
			openInfo: !openInfo,
		}));
	};

	private onChange(select) {
		this.setState({ value: select });

		let error;
		if (this.props.schema.extra.dataSrcUrl) {
			error = SelectBlockValidate(select, this.props.schema, this.props.opts, this.state.dataSrc?.data);
		} else {
			error = SelectBlockValidate(select, this.props.schema, this.props.opts);
		}

		if (isArray(select)) {
			this.props.dispatcher.onBlur(
				this.props.schema.id,
				isEmpty(select) ? null : select,
				!error,
				error && error.isError && { message: error.message }
			);
		} else {
			this.props.dispatcher.onBlur(
				this.props.schema.id,
				null,
				!error,
				error && error.isError && { message: error.message }
			);
		}
		this.props.dispatcher.onVisit(this.props.schema.id);
	}

	private setCurrent(treeItem, mode) {
		const {
			opts: { cities, tags, people },
			schema: { extra },
		} = this.props;
		const { dataSrc } = this.state;

		if (this.props.schema.disabled) {
			return;
		}
		let elements;

		if (dataSrc?.data) {
			elements = dataSrc.data;
		} else {
			switch (extra.init) {
				case "getTags":
					elements = tags;
					break;
				case "getCities":
					elements = cities;
					break;
				case "getPeople":
					elements = people;
					break;
				default:
					break;
			}
		}

		if (elements.filter((el) => el.parent_id === treeItem.id).length > 0 && mode !== "unselect") return;
		this.setState({
			currentItem: {
				...treeItem,
				mode,
			},
		});
	}

	private sortTreeByField = (items: Array<unknown>, sortBy: string, lang?: string) => {
		if (!Array.isArray(items)) {
			return [];
		}
		return items
			.map((item) => (item.children ? { ...item, children: this.sortTreeByField(item.children, sortBy, lang) } : item))
			.sort((a, b) => {
				if (a.item?.[sortBy]?.[lang] < b.item?.[sortBy]?.[lang]) {
					return -1;
				}
				if (a.item?.[sortBy]?.[lang] > b.item?.[sortBy]?.[lang]) {
					return 1;
				}
				return 0;
			});
	};

	private selectItem(event) {
		event.preventDefault();

		const { currentItem, value } = this.state;
		if (currentItem) {
			let newValue = null;
			if (value) {
				newValue = [...value, currentItem.id];
			} else {
				newValue = [currentItem.id];
			}
			this.onChange(newValue);
		}
		this.setState({ currentItem: null });
	}

	private unSelectItem(e) {
		e.preventDefault();
		const { currentItem, value } = this.state;
		if (currentItem) {
			const newValue = value.filter((item) => item !== currentItem.id);
			this.onChange(newValue);
		}
		this.setState({ currentItem: null });
	}

	private validate(data?: any) {
		const {
			schema: {
				value,
				extra: { dataSrcUrl },
			},
			error: existingError,
			opts,
		} = this.props;
		const { dataSrc } = this.state;

		let error = null;
		if (typeof value === "string" && JSON.parse(value).length > 0) {
			this.props.dispatcher.onVisit(this.props.schema.id);
			this.setState({ value: value && JSON.parse(value) });

			if (dataSrcUrl || data) {
				error = SelectBlockValidate(value, this.props.schema, opts, data ?? dataSrc?.data);
			} else {
				error = SelectBlockValidate(value, this.props.schema, opts);
			}
		} else if (value) {
			this.props.dispatcher.onVisit(this.props.schema.id);
			this.setState({ value });

			if (dataSrcUrl || data) {
				error = SelectBlockValidate(JSON.stringify(value), this.props.schema, opts, data ?? dataSrc?.data);
			} else {
				error = SelectBlockValidate(JSON.stringify(value), this.props.schema, opts);
			}
		}
		if (existingError) {
			return;
		}
		this.props.dispatcher.setError(
			this.props.schema.id,
			value,
			error && error.isError ? { message: error.message } : undefined,
			false
		);
	}

	private renderSublist(treeItem, currentItem, lang, index, action, selectedElements) {
		const maxSelected =
		typeof this.props.schema.maxSelected !== "undefined" &&
		this.props.schema.maxSelected > 0 &&
		this.props.schema.maxSelected >= this.props.schema.minSelected
			? this.props.schema.maxSelected
			: null;

		
		if (typeof treeItem.children === "undefined" || treeItem.children.length === 0) {
			return null;
		}

		return (
			<ul className="sort__sublist">
				{treeItem.children.map((child) => (
					<li key={child.item.id} className="sort__elem">
						{child.show && (
							<span
								role="button"
								tabIndex={index}
								onKeyDown={() => this.setCurrent(child.item, action)}
								onClick={() => this.setCurrent(child.item, action)}
								onDoubleClick={(e) => {
									if (!maxSelected || maxSelected > selectedElements.length) {
										this.setCurrent(treeItem.item, action);
										if (action === "select") {
											this.selectItem(e);
										} else {
											return;
										}
									}
									if (action === "unselect") {
										this.unSelectItem(e);
									} else {
										return;
									}
								}}
								className={`sort__elem-text
                					${currentItem && currentItem.id === child.item.id ? "sort__elem-text--active" : ""}
									${typeof child.children !== "undefined" && child.children.length > 0 ? "sort__elem-text--parent" : ""}
								`}
							>
								{getTitle(child.item.name, lang)}
							</span>
						)}
						{typeof child.children !== "undefined" &&
							child.children.length > 0 &&
							this.renderSublist(child, currentItem, lang, index, action, selectedElements)}
					</li>
				))}
			</ul>
		);
	}

	private getSelectedListWithTree(selectedItemList: any[], fullItemList) {
		const {
			schema: {
				extra: { renderSelectedViewTree },
			},
		} = this.props;

		if (renderSelectedViewTree && selectedItemList.length) {
			const filterTree = (tree, targetIds) => {
				const result = [];

				for (let node of tree) {
					if (targetIds.includes(node.item.id)) {
						result.push({ ...node, show: true }); // Добавляем текущий узел, если он имеет искомое значение
					} else if (node.children) {
						const filteredChildren = filterTree(node.children, targetIds);
						if (filteredChildren.length > 0) {
							result.push({
								item: node.item,
								show: true,
								children: filteredChildren,
							}); // Добавляем текущий узел, если один из его дочерних узлов имеет искомое значение
						}
					}
				}

				return result;
			};
			return filterTree(
				fullItemList,
				selectedItemList.map((item) => item.id)
			);
		}

		//Возвращаем плоский список
		return selectedItemList.map((item) => ({ item, children: undefined }));
	}

	public render() {
		const {
			schema: { extra, disabled },
			error,
			visited,
			opts: { cities, tags, people },
		} = this.props;
		const minSelected =
			typeof this.props.schema.minSelected !== "undefined" && this.props.schema.minSelected > 0
				? this.props.schema.minSelected
				: null;
		const maxSelected =
			typeof this.props.schema.maxSelected !== "undefined" &&
			this.props.schema.maxSelected > 0 &&
			this.props.schema.maxSelected >= this.props.schema.minSelected
				? this.props.schema.maxSelected
				: null;
		const { searchString, value, currentItem, dataSrc } = this.state;
		const lang = "ru";
		let elements;

		if (extra.dataSrcUrl) {
			if (dataSrc) {
				if (!dataSrc.loading) {
					if (!dataSrc.error) {
						elements = dataSrc.data;
					} else {
						return <div>error</div>;
					}
				} else {
					return <div>loading</div>;
				}
			} else {
				return <div>loading</div>;
			}
		} else {
			switch (extra.init) {
				case "getTags":
					elements = tags;
					break;
				case "getCities":
					elements = cities;
					break;
				case "getPeople":
					elements = people;
					break;
				default:
					break;
			}
		}

		const errorText = visited && error && error.message;
		let className = "default";
		let input = null;
		// Error
		if (errorText) {
			className = "error";
		}

		const selectedElements = elements?.filter((item) => value && value.indexOf(item.id) !== -1);
		// console.group();
		// console.log(this.props.schema);
		// console.log("elements", elements);
		// console.log("VALUE", value);
		// console.groupEnd();

		// нормализованное дерево
		const sourceTree = elements?.reduce(
			(acc, val) => ({
				...acc,
				[val.id]: val,
			}),
			{}
		);

		const mapTree = {};

		// скрыть выбранные элементы и преобразовать формат элемента из { el } в { item: { el } }
		// eslint-disable-next-line no-unused-expressions
		sourceTree &&
			Object.keys(sourceTree).forEach((key) => {
				mapTree[key] = { show: typeof mapTree[key] !== "undefined" ? mapTree[key].show : true };
				if (selectedElements) {
					if (typeof selectedElements.find((element) => element.id === sourceTree[key].id) !== "undefined") {
						mapTree[key].show = false;
					}
				}
				mapTree[key].item = { ...sourceTree[key] };
			});

		// расстановка дочерних элементов внутри плоского списка
		Object.keys(mapTree).forEach((key) => {
			if (mapTree[key].item.parent_id) {
				mapTree[mapTree[key].item.parent_id].children = [
					...(mapTree[mapTree[key].item.parent_id].children || []),
					mapTree[key],
				];
			}
		});

		let reducedTree = searchString
			? sourceTree &&
			  Object.keys(sourceTree)
					?.map((key) => mapTree[key])
					.filter((el) => {
						// фильтр поисковой строки
						if (typeof el.children !== "undefined" && el.children.length > 0) return false;

						// Если указан источник данных, не фильтруем по rootId
						if (extra.dataSrcUrl && searchString) {
							return typeof el.item.name === "string"
								? el.item.name.toLowerCase().includes(searchString.toLowerCase())
								: el.item.name?.ru?.toLowerCase().includes(searchString.toLowerCase());
						} else if (searchString)
							return (
								typeof el.item.name.ru === "string" &&
								el.item.name.ru.toLowerCase().includes(searchString.toLowerCase()) &&
								(extra.rootTagId !== undefined ? el.item.type_id === extra.rootTagId : true)
							);

						return true;
					})
			: Object.keys(mapTree)
					.map((key) => mapTree[key])
					.filter((el) => {
						// фильтрация пустых элементов
						if (!el) return false;

						// Если указан источник данных, не фильтруем по rootId
						if (extra.dataSrcUrl) {
							if (!el.item.parent_id) return true;
						} else {
							// корневые элементы многоуровневого списка
							if (extra.rootTagId && el.item.type_id === extra.rootTagId && !el.item.parent_id) return true;
							// все элементы плоского списка
							if (typeof extra.rootTagId === "undefined") return true;
						}
						// очистка многоуровнего списка от неструктурных элемнетов
						return false;
					});

		if (this.props.schema?.extra?.sortBy) {
			const { sortBy } = this.props.schema?.extra;
			reducedTree = this.sortTreeByField(reducedTree, sortBy, lang);
		}

		const selectBlock = (
			<div className={`sort ${disabled ? "disabled" : ""}`}>
				<div className="sort__group">
					{!disabled && (
						<>
							<div className="sort__block">
								<div className="sort__input-wrapper">
									<input
										className="sort__input"
										placeholder={extra.captions && extra.captions.all && getTitle(extra.captions.all, lang)}
										onChange={(e) => this.setState({ searchString: e.target.value })}
									/>
								</div>
								<ul className="sort__list">
									{reducedTree &&
										reducedTree.map((treeItem, index) => (
											<li key={treeItem.item.id} className="sort__elem">
												{treeItem.show && (
													<span
														role="button"
														tabIndex={index}
														className={`sort__elem-text
                            ${currentItem && currentItem.name === treeItem.item.name ? "sort__elem-text--active" : ""}
                            ${
															typeof treeItem.children !== "undefined" && treeItem.children.length > 0
																? "sort__elem-text--parent"
																: ""
														}
                          `}
														onKeyDown={() => this.setCurrent(treeItem.item, "select")}
														onClick={() => this.setCurrent(treeItem.item, "select")}
														onDoubleClick={(e) => {
															if (!maxSelected || maxSelected > selectedElements.length) {
																this.setCurrent(treeItem.item, "select");
																this.selectItem(e);
															} else {
																return
															}
														}}
													>
														{getTitle(treeItem.item.name, lang)}
													</span>
												)}
												{!searchString && this.renderSublist(treeItem, currentItem, lang, index, "select", selectedElements)}
											</li>
										))}
									{!reducedTree?.length && (
										<li className="sort__elem" style={{ color: "#d8dce2" }}>
											Список пуст
										</li>
									)}
								</ul>
							</div>

							<div className="sort__arrows">
								{(!maxSelected || maxSelected > selectedElements.length) && (
									<a
										href="/"
										className={`sort__arrow__link sort__arrow--right ${
											currentItem && currentItem.mode === "select" ? "sort__arrow--active" : ""
										}`}
										onClick={(e) => this.selectItem(e)}
									>
										{(currentItem && currentItem.mode === "select" && <ArrowActive />) || <Arrow />}
									</a>
								)}
								<a
									href="/"
									className={`sort__arrow__link sort__arrow--left ${
										currentItem && currentItem.mode === "unselect" ? "sort__arrow--active" : ""
									}`}
									onClick={(e) => this.unSelectItem(e)}
								>
									{(currentItem && currentItem.mode === "unselect" && <ArrowActive />) || <Arrow />}
								</a>
							</div>
						</>
					)}
					<div className="sort__block">
						{!disabled && (
							<div className="sort__head">
								{extra.captions && extra.captions.selected && getTitle(extra.captions.selected, lang)}
							</div>
						)}
						<ul className="sort__list">
							{this.getSelectedListWithTree(selectedElements, reducedTree)?.map((selectedTag, index) => (
								<li key={selectedTag.item.id} className="sort__elem">
									<span
										role="button"
										tabIndex={index}
										className={`sort__elem-text
											${currentItem && currentItem.name === selectedTag.item.name ? "sort__elem-text--active" : ""}
											${typeof selectedTag.children !== "undefined" && selectedTag.children.length > 0 ? "sort__elem-text--parent" : ""}
                          				`}
										onKeyDown={() => this.setCurrent(selectedTag.item, "unselect")}
										onClick={() => this.setCurrent(selectedTag.item, "unselect")}
										onDoubleClick={(e) => {
											this.setCurrent(selectedTag.item, "unselect");
											this.unSelectItem(e);
										}}
									>
										{getTitle(selectedTag.item.name, lang)}
									</span>
									{this.renderSublist(selectedTag, currentItem, lang, index, "unselect", selectedElements)}
								</li>
								// <li key={selectedTag.id} className="sort__elem">
								// 	<span
								// 		className={`sort__elem-text ${
								// 			currentItem && currentItem.id === selectedTag.id
								// 				? "sort__elem-text--active"
								// 				: ""
								// 		}`}
								// 		role="button"
								// 		tabIndex={index}
								// 		onKeyDown={() => this.setCurrent(selectedTag, "unselect")}
								// 		onClick={() => this.setCurrent(selectedTag, "unselect")}
								// 		onDoubleClick={(e) => {
								// 			this.setCurrent(selectedTag, "unselect");
								// 			this.unSelectItem(e);
								// 		}}
								// 	>
								// 		{getTitle(selectedTag.name, lang)}
								// 	</span>
								// </li>
							))}
						</ul>
					</div>
				</div>
			</div>
		);

		input = !isUndefined(this.props.schema.description) ? (
			<div className="input-group" style={{ width: "100%" }}>
				{selectBlock}
				<Help onClick={this.onClick} />
			</div>
		) : (
			selectBlock
		);

		// console.log(this.props.dispatcher);

		return (
			<Field {...this.props.schema} status={className}>
				{extra && extra.hint && (
					<div className="alert alert-info hint" dangerouslySetInnerHTML={{ __html: extra.hint }} />
				)}
				{input}
				{(minSelected || maxSelected) && (
					<div className="input-counter">
						Всего: {value && value.length > 0 ? value.length : 0}&nbsp;
						{value &&
							value.length >= minSelected &&
							maxSelected > minSelected &&
							`(Осталось: ${value ? maxSelected - value.length : 0})`}
						{value && value.length < minSelected && `(Не хватает: ${value ? minSelected - value.length : minSelected})`}
					</div>
				)}
				{!isUndefined(this.props.schema.description) && this.state.openInfo && (
					<div
						className="alert alert-warning"
						role="alert"
						dangerouslySetInnerHTML={{ __html: this.tr(this.props.schema.description) }}
					/>
				)}
				<ErrorAlert errorMessage={errorText} />
				{extra && extra.note && <Note content={extra.note} dispatcher={this.props.dispatcher} />}
			</Field>
		);
	}
}

export function createSelectBlock(
	schema: IControlSchema,
	api: any,
	dispatcher: IDispatcher = null,
	error: IControlError | undefined,
	visited: boolean,
	opts: any
): React.ReactElement<any> {
	return (
		<SelectBlock
			schema={schema as ISelectBlockSchema}
			api={api}
			dispatcher={dispatcher}
			error={error}
			visited={visited}
			opts={opts}
		/>
	);
}
